import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectUser } from 'redux/slices/userSlice';
import { getCompanies } from 'services/rest/SuperAdmin/Company/getCompanies';
import SectionWrapper from 'pages/Layout/SectionWrapper';
import DropdownSearchable from 'components/inputs/DropdownSearchable';
import { InputWrapper } from '../Styled';
import LogsTable from './LogsTable';

const LogsPage: React.FC = () => {
  const { t } = useTranslation(['super_admin_administrator']);
  const { currentUser } = useSelector(selectUser);

  const [companies, setCompanies] = useState<any[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<string | null>(null);

  const getCompanyData = async () => {
    const { data } = await getCompanies(currentUser?.token, 500, 1);
    if (data) setCompanies(data);
  };

  const handleCompanyChange = (option: any) => {
    setSelectedCompany(option?.value || null);
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  const companyOptions =
    companies?.map((company: any) => ({
      value: company.id,
      label: company.name
    })) || [];

  return (
    <SectionWrapper>
      <h1>{t('logs:filter_logs')}</h1>

      <InputWrapper>
        <label>{t('super_admin_administrator:form:company')}</label>
        <div className="w-100">
          <DropdownSearchable
            name="companyId"
            isSearchable
            placeHolder="Seleccione una compañia"
            options={companyOptions}
            onChange={handleCompanyChange}
          />
        </div>
      </InputWrapper>

      <LogsTable selectedCompany={selectedCompany} />
    </SectionWrapper>
  );
};

export default LogsPage;
